import { Alert, Divider, Paper, Stack, Typography } from '@mui/material';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import PageMain from '../components/Navigation/PageMain/PageMain';
import AxiosErrorAlert from '../components/Shared/Alerts/AxiosErrorAlert';
import Loader from '../components/Shared/Loader';
import { useAiSmartReplyContactPlanEvent } from '../sic-lib/api/hooks/useAiSmartReply';

export default function AiContactPlanItemEventPage() {
    const { contactPlanItemId } = useParams<{ contactPlanItemId?: string }>();
    var { data, isLoading, error } = useAiSmartReplyContactPlanEvent(Number(contactPlanItemId));

    const info = useMemo(() => {
        if (!data) {
            return null;
        }

        const parsedResponse = JSON.parse(data.completionResponse);

        console.log(parsedResponse.Prompt.Prompt);

        return {
            prompt: parsedResponse.Prompt.Prompt,
            message: parsedResponse.Message,
        };
    }, [data]);

    return (
        <PageMain
            pageTitle="AI Smart Reply Contact Plan Item Event"
            showError={false}
            showLoading={false}
        >
            <div className="settingsPage">
                <Loader isLoading={isLoading}>
                    <Stack spacing={2} p={2}>
                        <AxiosErrorAlert error={error} />
                        {!data && <Alert severity="info">No data available</Alert>}
                        {data && info && (
                            <>
                                <Paper sx={{ p: 2, whiteSpace: 'pre-wrap' }}>
                                    <Stack spacing={2}>
                                        <Typography variant="h6">Prompt</Typography>
                                        <Divider />
                                        <Typography variant="body1">{info.prompt}</Typography>
                                    </Stack>
                                </Paper>
                                <Paper sx={{ p: 2, whiteSpace: 'pre-wrap' }}>
                                    <Stack spacing={2}>
                                        <Typography variant="h6">Response</Typography>
                                        <Divider />
                                        <Typography variant="body1">{info.message}</Typography>
                                    </Stack>
                                </Paper>
                                <Paper sx={{ p: 2 }}>
                                    <Typography variant="h6">Completion Response</Typography>
                                    <pre style={{ whiteSpace: 'pre-wrap' }}>
                                        {JSON.stringify(
                                            JSON.parse(data.completionResponse),
                                            null,
                                            2,
                                        )}
                                    </pre>
                                </Paper>
                                <Paper sx={{ p: 2 }}>
                                    <Typography variant="h6">Prompt Event</Typography>
                                    <pre style={{ whiteSpace: 'pre-wrap' }}>
                                        {JSON.stringify(data, null, 2)}
                                    </pre>
                                </Paper>
                            </>
                        )}
                    </Stack>
                </Loader>
            </div>
        </PageMain>
    );
}
